import type { SVGProps } from 'react';
const DawnFlagGQ = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-GQ_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-GQ_svg__a)">
      <path fill="#EC3938" d="M0 16h22v-5.333H0z" />
      <path fill="#51B422" d="M0 5.333h22V0H0z" />
      <path
        fill="#159940"
        d="M10.69 9.372a.14.14 0 0 0 .038-.092l.009-1.58a.23.23 0 0 0-.232-.233.232.232 0 0 1-.166-.395l.423-.43a.333.333 0 0 1 .476 0l.422.43a.232.232 0 0 1-.166.395.23.23 0 0 0-.232.232v1.58q0 .054.038.093a.134.134 0 0 1-.096.228h-.415a.135.135 0 0 1-.098-.228"
      />
      <path fill="#258DE7" d="m0 0 7.333 8L0 16z" />
    </g>
  </svg>
);
export default DawnFlagGQ;
